module.exports = __webpack_public_path__ + "static/media/law.f3f1c2d4.jpg";